import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'

import NewWar from '../views/WAR-Reports/New-War.vue'
import ResetPasswordSelf from '../views/Reset-Password.vue'
import AssignContractData from '../views/Administration/AssignContractData.vue'
import CreateNewUser from '../views/Administration/New-User.vue'
import store from '../store'
import EditSavedWar from '../views/WAR-Reports/Edit-Saved-War.vue'
import SubmittedWar from '../views/WAR-Reports/Submitted-War.vue'
import SubmittedMonthly from '../views/WAR-Reports/Submitted-Monthly.vue'
import ViewEditUser from '../views/Administration/View-Edit-User-Page.vue'
import EditUser from '../views/Administration/Edit-User.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import EditHomepage from '../views/Marketing/EditHomePage.vue'
import MyAccount from '../views/MyAccount.vue'
import EmployeeDirectory from '../views/Resources/EmployeeDirectory.vue'
import VisitorInformation from '../views/Administration/VisitorInformation.vue'
import SubmitSupportTicket from '../views/IT/SubmitSupportTicket.vue'
import TicketStatus from '../views/IT/SubmitSupportTicket.vue'
import SupportTicket from '../views/IT/SupportTicket.vue'
import AssetTracking from '../views/IT/AssetTracking.vue'
import QPRForm from '../views/Project-Overview/QPR-Form.vue'
import ReviewQPR from '../views/Project-Overview/View-QPR.vue'
import ViewSubmittedQPR from '../views/Project-Overview/View-QPR.vue'
import ViewQCR from '../views/Project-Overview/Review-QCR.vue'
import PendingQCR from '../views/Project-Overview/Review-QCR.vue'
import ViewEditBuild from '../views/Project-Overview/ViewEdit-Build.vue'
import ManageProjects from '../views/Project-Overview/Review-Projects.vue'
import QIPForm from '../views/Project-Overview/QIP-Form.vue'
import STRForm from '../views/Project-Overview/STR-Form.vue'
import ITCRForm from '../views/IT/ITCR-Form.vue'
import ITCR from '../views/IT/ITCR.vue'
import ViewITCR from '../views/IT/ViewITCR.vue'
//import TimestampReport from '../views/Supervisor-Tools/TimestampReport.vue'
//import ResetUserPassword from '../views/IT/ResetPassword.vue'
//import WARSubStatus from '../views/Administrator-Tools/WAR-Submission-Status.vue'
import auditITCR from '../views/Administration/auditITCR.vue'
import viewITCRDetails from '../views/Administration/ViewITCRDetails.vue'
import SMSTextingPolicy from '../views/SMSTextingPolicy.vue'

import axios from 'axios';
import { getEndpoint } from '@/assets/js/DatabaseLib.js'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/Login',
    name: 'Login',
    redirect: "",
    component: Login
  },
  {
    path: '/SMSTextingPolicy',
    name: 'SMSTextingPolicy',
    component: SMSTextingPolicy,
  },
  {
    path: '/ForgotPassword',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/My-Account',
    name: 'My-Account',
    component: MyAccount,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/WAR-Reports/Create-New-Report',
    alias: ['/WAR-Reports/New-War/:id'],
    name: 'New-War',
    component: NewWar,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/WAR-Reports/Edit-Saved-Reports',
    name: 'Edit-Saved-War',
    component: EditSavedWar,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/WAR-Reports/View-Submitted-Reports',
    name: 'Submitted-War',
    component: SubmittedWar,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/WAR-Reports/View-Monthly-Report',
    name: 'Submitted-Monthly',
    component: SubmittedMonthly,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/ResetPassword',
    name: 'ResetPasswordSelf',
    component: ResetPasswordSelf
  },
  {
    path: '/ManageContractData',
    name: 'AssignContractData',
    component: AssignContractData,
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: '/Create-New-User',
    name: 'New-User',
    component: CreateNewUser,
    meta: {
      requiresAuth: true,
      requiresIT: true
    }
  },
  {
    path:'/View-Edit-User-Page',
    name: 'View-Edit-User-Page',
    component: ViewEditUser,
    meta: {
      requiresAuth: true,
      requiresIT: true
    }
  },
  {
    path:'/auditITCR',
    name: 'auditITCR',
    component: auditITCR,
    meta: {
      requiresAuth: true,
      requiresCMAdmin: true
    }
  },
  {
    path:'/viewITCRDetails',
    name: 'viewITCRDetails',
    component: viewITCRDetails,
    meta: {
      requiresAuth: true,
      requiresCMAdmin: true
    }
  },
  {
    path: '/Edit-User/:id',
    name: 'Edit-User',
    component: EditUser,
    meta: {
      requiresAuth: true,
      requiresIT: true
    }
  },
  {
    path: '/Edit-Homepage',
    name: 'Edit-Homepage',
    component: EditHomepage,
    meta: {
      requiresAuth: true,
      requiresMarketing: true
    }
  },
  {
    path: '/Resources/Employee-Directory',
    name: 'Employee-Directory',
    component: EmployeeDirectory,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/Visitor-Log',
    name: 'Visitor-Information',
    component: VisitorInformation,
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: '/IT/SubmitSupportTicket',
    name: 'SubmitSupportTicket',
    component: SubmitSupportTicket,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/IT/TicketStatus',
    name: 'TicketStatus',
    component: TicketStatus,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/IT/ManageSupportTicket',
    name: 'SupportTicket',
    component: SupportTicket,
    meta: {
      requiresAuth: true,
      requiresIT: true
    }
  },
  {
    path: '/IT/AssetTracking',
    name: 'AssetTracking',
    component: AssetTracking,
    meta: {
      requiresAuth: true,
      requiresIT: true
    }
  },
  {
    path: '/IT/ITCR-Form',
    name: 'ITCR-Form',
    component: ITCRForm,
    meta: {
      requiresAuth: true,
      requiresIT: true
    }
  },
  {
    path: '/IT/ITCR',
    name: 'ITCR',
    component: ITCR,
    meta: {
      requiresAuth: true,
      requiresITCCB: true
    }
  },
    {
    path: '/IT/ViewITCR',
    name: 'ViewITCR',
    component: ViewITCR,
    meta: {
      requiresAuth: true,
      requiresITCCB: true
    }
  },
  /*{
    path: '/IT/ResetPassword',
    name: 'ResetUserPassword',
    component: ResetUserPassword,
    meta: {
      requireAuth: true,
      requiresIT: true
    }
  },*/
  {
    path: '/Project-Overview/QPR-Form',
    name: 'QPRForm',
    component: QPRForm,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/Project-Overview/QIP-Form',
    alias: ['/Project-Overview/QIP-Form:id'],
    name: 'QIP-Form',
    component: QIPForm,
    props: true,
    meta: {
      requiresAuth: true,
      requiresMultiple: true
    }
  },
  {
    path: '/Project-Overview/STR-Form',
    alias: ['/Project-Overview/STR-Form:id'],
    name: 'STR-Form',
    component: STRForm,
    props: true,
    meta: {
      requiresAuth: true,
      requiresMultiple: true
    }
  },
  {
    path: '/Project-Overview/Review-Products',
    name: 'ManageProjects',
    component: ManageProjects,
    meta: {
      requiresAuth: true,
      requiresMultiple: true,
    }
  },
   {
    path: '/Project-Overview/View-QPR',
    name: 'ViewSubmittedQPR',
    component: ViewSubmittedQPR,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/Project-Overview/Review-QPR',
    name: 'ReviewQPR',
    component: ReviewQPR,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/Project-Overview/Review-QCR',
    name: 'ViewQCR',
    component: ViewQCR,
    props: true,
    meta: {
      requiresAuth: true,
      requiresMultiple: true
    }
  },
  {
    path: '/Project-Overview/Pending-QCR',
    name: 'PendingQCR',
    component: PendingQCR,
    meta: {
      requiresAuth: true,
      requiresProductCCB: true
    }
  },
  {
    path: '/Project-Overview/ViewEdit-Build',
    alias: ['/Project-Overview/ViewEdit-Build/:id/:project'],
    name: 'ViewEditBuild',
    component: ViewEditBuild,
    props: true,
    meta: {
      requiresAuth: true,
      requiresMultiple: true
    }
  },
  /*{
    path: '/Supervisor-Tools/TimestampReport',
    name: 'TimestampReport',
    component: TimestampReport,
    meta: {
      requiresAuth: true,
      requiresSupervisor: true
    }
  },*/
 /* {
    path: '/Administrator-Tools/WARSubmissionStatus',
    name: 'WARSubmissionStatus',
    component: WARSubStatus,
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  }*/
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth'
      };
    }

    return { x: 0, y: 0 };
  }
})

// Sends get request to check if token is still valid. If it isn't, redirects to login page
async function checkToken(token) {
  let response = await axios.get(getEndpoint('strapiDatabase') + 'api/users/me', { headers: { Authorization: 'Bearer '+ token }})
  .then(response => {
    return response;
  })
  .catch(function (error) {
    return error.response.data.message;
  })

  if (typeof response == 'string')
  {
    store.dispatch('logout');
    router.push({ name: 'Login', params: { p2: true }});
  }
}

async function checkITCCB(){
  let query = "filters[username][$eq][0]="+ store.getters.getUser;
  let response =  await axios.get(getEndpoint('strapiDatabase') + 'api/itcr-ccb-members?'+query, { headers: { Authorization: 'Bearer '+ store.getters.getToken }})
  .then(response => {
    return response;
  })
  .catch(function (error) {
    return error.response.data.message;
  })

  if(response.data.data.length > 0){
    return true;
  } else {
    return false;
  }
}

router.beforeEach(async (to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {

      //--------------------------------------------------------
      // Check if Token is still valid
      //--------------------------------------------------------
      if(store.getters.getToken) {
        checkToken(store.getters.getToken);
      }
      localStorage.setItem('previousRoute', from.name);
      
      //--------------------------------------------------------
      // Check Administration Role
      //--------------------------------------------------------
      if(to.matched.some(record => record.meta.requiresAdmin)) {
        if (store.getters.getGroups.includes('Administration')) {
          next()
          return
        }
        next('/')
      }


      //--------------------------------------------------------
      // Check Marketing Role
      //--------------------------------------------------------
      if(to.matched.some(record => record.meta.requiresMarketing)) {
        if (store.getters.getGroups.includes('Marketing')) {
          next()
          return
        }
        next('/')
      }

      //--------------------------------------------------------
      // Check Supervisor Role
      //--------------------------------------------------------
      if(to.matched.some(record => record.meta.requiresSupervisor)) {
        if (store.getters.getGroups.includes('Supervisor')) {
          next()
          return
        }
        next('/')
      }
      
      //--------------------------------------------------------
      // Check IT Role
      //--------------------------------------------------------
      if(to.matched.some(record => record.meta.requiresIT)) {
        if (store.getters.getGroups.includes('IT')) {
          next()
          return
        }
        next('/')
      }
      //--------------------------------------------------------
      // Check IT and CM Role
      //--------------------------------------------------------
      if(to.matched.some(record => record.meta.requiresITCCB)) {
        let result = await checkITCCB();
        if (store.getters.getGroups.includes('IT') || store.getters.getGroups.includes('CM') || (store.getters.getGroups.includes('CCB') && result)) {
          next()
          return
        }
        next('/')
      }

      //--------------------------------------------------------
      // Check Admin and CM Role
      //--------------------------------------------------------
      if(to.matched.some(record => record.meta.requiresCMAdmin)) {
        if (store.getters.getGroups.includes('Administration') || store.getters.getGroups.includes('CM')) {
          next()
          return
        }
        next('/')
      }
      //-------------------------------------------------------

      //--------------------------------------------------------
      // Check PM Role
      //--------------------------------------------------------
      if(to.matched.some(record => record.meta.requiresPM)) {
        if (store.getters.getGroups.includes('Project Manager')) {
          next()
          return
        }
        next('/')
      }
      //-------------------------------------------------------

      //--------------------------------------------------------
      // Check CM Role
      //--------------------------------------------------------
      if(to.matched.some(record => record.meta.requiresCM)) {
        if (store.getters.getGroups.includes('CM')) {
          next()
          return
        }
        next('/')
      }
      //-------------------------------------------------------

      //--------------------------------------------------------
      // Check CCB Role
      //--------------------------------------------------------
      if(to.matched.some(record => record.meta.requiresCCB)) {
        if (JSON.parse(store.getters.getCCBGroups).length > 0) {
          next()
          return
        }
        next('/')
      }
      //-------------------------------------------------------

      //--------------------------------------------------------
      // Check Product CCB Roles
      //--------------------------------------------------------
      if(to.matched.some(record => record.meta.requiresProductCCB)) {
        if ((store.getters.getGroups.includes('CCB') && JSON.parse(store.getters.getCCBGroups).length > 0) || store.getters.getGroups.includes('Project Manager')
        || store.getters.getGroups.includes('CM')) {
          next()
          return
        }
        next('/')
      }

      //--------------------------------------------------------
      // Check multiple Roles
      //--------------------------------------------------------
      if(to.matched.some(record => record.meta.requiresMultiple)) {
        if ((store.getters.getGroups.includes('CCB') && JSON.parse(store.getters.getCCBGroups).length > 0) || store.getters.getGroups.includes('Project Manager')
        || store.getters.role == 'Administrator' || store.getters.getGroups.includes('CM') 
        || store.getters.getGroups.includes('Developer')) {
          next()
          return
        }
        next('/')
      }

      
      //-------------------------------------------------------
      next()
      return
    }
    next('/Login')
  } else {
    next()
  }

})

export default router
